import { Injectable } from "@angular/core";
import { SessionStorageKeys } from "@shared/services/static/session-storage-keys";

@Injectable({
    providedIn: "root",
})
export class SessionStorageService {
    setItem(key: SessionStorageKeys, value: string): void {
        sessionStorage.setItem(key, value);
    }

    getItem(key: SessionStorageKeys): string | null {
        return sessionStorage.getItem(key);
    }

    removeItem(key: SessionStorageKeys): void {
        sessionStorage.removeItem(key);
    }

    clearAllState(): void {
        sessionStorage.clear();
    }

    clearAcwState(): void {
        sessionStorage.removeItem(SessionStorageKeys.ScopedCenter);
        sessionStorage.removeItem(SessionStorageKeys.LastUrl);
    }
}
